import { BecomeFundraiserRequestDto } from 'services/user/userService.dto';

import { BecomeFundraiserFormData } from './useBecomeFundraiserForm';

export const convertFormDataToBecomeFundraiserDto = (
  formData: BecomeFundraiserFormData
): BecomeFundraiserRequestDto => {
  const hasBankData = !!formData.routingNumber && !!formData.accountNumber && !!formData.accountType;
  return {
    fundraiserType: formData.isIndividual ? 'PRIVATE' : formData.organization?.isNonProfit ? 'PUBLIC' : 'FOR_PROFIT',
    accountNumber: hasBankData ? formData.accountNumber : undefined,
    accountOrigin: hasBankData ? (formData.isIndividual ? 'PERSONAL' : 'BUSINESS') : undefined,
    accountType: hasBankData ? formData.accountType : undefined,
    addressLine1: formData.organization!.addressLine1,
    addressLine2: formData.organization!.addressLine2,
    city: formData.organization!.city,
    country: formData.organization!.country,
    ein: formData.organization!.ein,
    email: formData.email!,
    mobilePhone: formData.mobilePhone!,
    organizationName: formData.organization!.name,
    routingNumber: hasBankData ? formData.routingNumber : undefined,
    state: formData.organization!.state,
    zipCode: formData.organization!.zipCode,
  };
};
